<style type="text/css">
  .c-block {
    width: 100%;
    height: 100%;
    z-index: 1010;
    min-height: 100px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }

  .c-block-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
    width: 70px;
    height: 70px;
  }

  .c-block-transparent {
  }

  .c-block-opaque {
    background-color: #ffffff;
    opacity: .5;
  }
</style>

<template>
  <div class="c-block" :class="{'c-block-transparent': transparent, 'c-block-opaque' : !transparent }">
    <div class="c-block-spinner">
      <img v-if="img !== ''" :class="Core.Session.getValue('SessionBranchLogoLoadingAnimationClass', 'environment.ui.logoLoadingAnimationClass')" :width="Core.Session.getValue('SessionBranchLogoLoadingWidth', 'environment.ui.logoLoadingWidth')" :src="img">
      <Spinner v-if="img == ''" :spinner="spinner"></Spinner>
    </div>
  </div>
</template>

<script>
  import Spinner from './Spinner'
  export default {
    name: 'Block',
    components: {
      Spinner
    },
    props: {
      spinner: {
        type: String,
        default: 'wave'
      },
      img: {
        type: String,
        default: ''
      },
      transparent: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    data: () => {
      return {
        Core: window.Core
      }
    }
  }
</script>
